import { Box } from "@mui/material";
import { useState } from "react";
import DetailsEquipment from "../../components/leaderGroup/equipment/detailsEquipment";
import NewEquipment from "../../components/leaderGroup/equipment/newEquipment";

export default function Equipment({ notGroup }) {
  const [mode, setMode] = useState("table");
  const [equipmentIdFromUpdate, setEquipmentIdFromUpdate] = useState();

  return (
    <Box>
      {mode === "table" && (
        <DetailsEquipment
          setEquipmentIdFromUpdate={setEquipmentIdFromUpdate}
          notGroup={notGroup}
          setMode={setMode}
        />
      )}
      {mode === "new" && (
        <NewEquipment
          // dataTableAll={dataTable}
          // setDataTableAll={setDataTable}
          equipmentIdFromUpdate={equipmentIdFromUpdate}
          mode={mode}
          setMode={setMode}
        />
      )}
      {/* {mode === "update" && (
        <NewEquipment equipmentIdFromUpdate={equipmentIdFromUpdate} mode={mode} setMode={setMode} />
      )} */}
    </Box>
  );
}
